<div class="card">
  <p-tabs class="transparent" [value]="activeTab()" (valueChange)="onTabChange($event)">
    <p-tablist>
      <p-tab [value]="0">
        <div class="flex align-items-center gap-2">
          <app-calendar-check-01
            [stroke]="activeTab() === 0 ? '#181D27' : '#7E838F'"
            width="16px"
            height="16px"
          ></app-calendar-check-01>
          <span class="text-sm-semibold">Predstojeći</span>
        </div>
      </p-tab>
      <p-tab [value]="1">
        <div class="flex align-items-center gap-2">
          <app-clock-rewind
            [stroke]="activeTab() === 1 ? '#181D27' : '#7E838F'"
            width="16px"
            height="16px"
          ></app-clock-rewind>
          <span class="text-sm-semibold">Istorija</span>
        </div>
      </p-tab>
    </p-tablist>
  </p-tabs>

  <div class="mt-3 flex flex-column gap-3">
    @if (isLoading) {
      @for (row of [1, 2, 3]; track row) {
        <div class="appt-row flex align-items-center gap-3">
          <p-skeleton width="3rem" height="2.75rem"></p-skeleton>
          <div class="flex flex-column gap-2">
            <p-skeleton width="7rem"></p-skeleton>
            <p-skeleton width="4rem" height="1.25rem"></p-skeleton>
          </div>
        </div>
      }
    } @else if (appointments.length === 0) {
      <div class="empty-state flex flex-column align-items-center justify-content-center gap-2 py-5">
        <div class="empty-state__icon">
          <app-info-circle stroke="#ADB0B8" width="20px" height="20px"></app-info-circle>
        </div>
        @if (activeTab() === 0) {
          <div class="text-md-semibold text-gray-900">Nemate zakazanih termina</div>
          <div class="text-sm-regular text-gray-600">
            @if (isClientView()) {
              Ovde će se prikazati vaši predstojeći termini kada budu zakazani.
            } @else {
              Ovde će se prikazati predstojeći termini klijenta kada budu zakazani.
            }
          </div>
          @if (isClientView() && packageState.canBook()) {
            <app-button
              class="mt-2"
              [btnSize]="ButtonSize.MD"
              [btnSeverity]="ButtonSeverity.PRIMARY"
              (btnClicked)="goToCreateAppointment()"
            >
              <app-clock stroke="white" width="16px" height="16px"></app-clock>
              <div class="text-sm-semibold text-white ml-2">Zakažite termin</div>
            </app-button>
          }
        } @else {
          <div class="text-md-semibold text-gray-900">Nema prethodnih termina</div>
          <div class="text-sm-regular text-gray-600">
            Ovde će se prikazati svi ranije realizovani termini.
          </div>
        }
      </div>
    } @else {
      @for (appt of appointments; track appt.id) {
        <div
          class="appt-row flex align-items-center justify-content-between gap-3 cursor-pointer"
          (click)="openDetails(appt.id!)"
        >
          <div class="flex align-items-center gap-3">
            <div class="date-tile flex flex-column align-items-center">
              <div class="date-tile-month">{{ getMonthLabel(appt.from) }}</div>
              <div class="date-tile-day text-sm-semibold text-gray-900">{{ getDayLabel(appt.from) }}</div>
              <!-- Year on both tabs, so the tiles match (and stay clear across New Year) -->
              <div class="date-tile-year">{{ appt.from?.getFullYear() }}</div>
            </div>
            <div class="flex flex-column gap-1">
              <div class="text-sm-medium text-gray-900 white-space-nowrap">{{ formatTimeRange(appt.from, appt.to) }}</div>
              <div>
                <p-chip [label]="getStatusLabel(appt)" [class]="getStatusClass(appt)"></p-chip>
              </div>
            </div>
          </div>

          <div class="flex align-items-center gap-2-5">
            @if (isClientView() && activeTab() === 0 && appt.isAttachmentMissing) {
              <div class="missing-file">
                <app-alert-triangle stroke="#DC6803"></app-alert-triangle>
                <div class="missing-file__label text-xs-medium text-gray-700">Nedostaje fajl</div>
              </div>
            }

            @if (activeTab() === 0) {
              <div class="row-actions-desktop">
                @if (!appt.isShortNotice) {
                  <app-button
                    [btnSeverity]="ButtonSeverity.SECONDARY"
                    [btnSize]="ButtonSize.SM"
                    (btnClicked)="openRescheduleDialog(appt.id!, $event)"
                  >
                    <app-edit-03 stroke="#181D27"></app-edit-03>
                    <div class="text-sm-semibold text-gray-900">Izmeni</div>
                  </app-button>
                }
                <app-button
                  [btnSeverity]="ButtonSeverity.SECONDARY"
                  [btnSize]="ButtonSize.SM"
                  (btnClicked)="openCancelDialog(appt.id!, $event)"
                >
                  <app-slash-circle-01 stroke="#181D27"></app-slash-circle-01>
                </app-button>
              </div>

              <button
                type="button"
                class="row-actions-mobile"
                (click)="openRowMenu(appt, $event)"
                aria-label="Akcije"
              >
                <i class="pi pi-ellipsis-v"></i>
              </button>
            }
          </div>
        </div>
      }
    }
  </div>

  <p-menu #rowMenu [popup]="true" [model]="rowMenuItems" appendTo="body"></p-menu>

  @if (!isLoading && appointments.length > 0) {
    <div class="pagination-container mt-3 flex align-items-center justify-content-between gap-2">
      <app-button
        [btnSize]="ButtonSize.SM"
        [btnSeverity]="ButtonSeverity.SECONDARY"
        (btnClicked)="prev()"
        [isBtnDisabled]="!paginatedData.hasPreviousPage"
      >
        <app-arrow direction="left" stroke="#3D3B3A"></app-arrow>
        <div class="text-sm-semibold text-gray-700">Nazad</div>
      </app-button>

      <p-paginator
        [rows]="paginatedData.pageSize!"
        [totalRecords]="paginatedData.totalCount!"
        [first]="first"
        (onPageChange)="onPageChange($event)"
        styleClass="custom-paginator"
      ></p-paginator>

      <app-button
        [btnSize]="ButtonSize.SM"
        [btnSeverity]="ButtonSeverity.SECONDARY"
        (btnClicked)="next()"
        [isBtnDisabled]="!paginatedData.hasNextPage"
      >
        <div class="text-sm-semibold text-gray-700">Dalje</div>
        <app-arrow direction="right" stroke="#3D3B3A"></app-arrow>
      </app-button>
    </div>
  }
</div>

@if (isClientView()) {
  <app-client-appointment-reschedule-dialog
    [(visible)]="showRescheduleDialog"
    [appointmentId]="selectedRescheduleId()"
    (rescheduled)="onRescheduled()"
  ></app-client-appointment-reschedule-dialog>

  <app-client-appointment-cancel-dialog
    [(visible)]="showCancelDialog"
    [appointmentId]="selectedCancelId()"
    (cancelled)="onCancelled()"
  ></app-client-appointment-cancel-dialog>

  <app-client-appointment-details-drawer
    [(visible)]="showDetailsDrawer"
    [appointmentId]="selectedDetailsId()"
    (cancelled)="onDetailsAction()"
    (rescheduled)="onDetailsAction()"
    (documentUploaded)="onDetailsAction()"
  ></app-client-appointment-details-drawer>
} @else {
  <app-appointment-reschedule-dialog
    [(visible)]="showRescheduleDialog"
    [appointmentId]="selectedRescheduleId()"
    (rescheduled)="onRescheduled()"
  ></app-appointment-reschedule-dialog>

  <app-appointment-details-drawer
    [(visible)]="showDetailsDrawer"
    [appointmentId]="selectedDetailsId()"
    (onCancel)="onDetailsAction()"
    (onRescheduled)="onDetailsAction()"
  ></app-appointment-details-drawer>

  @if (selectedCancelId()) {
    <p-dialog
      [(visible)]="showCancelDialog"
      [modal]="true"
      [closable]="false"
      [style]="{ width: '25rem' }"
    >
      <div class="flex flex-column">
        <div class="text-lg-semibold text-gray-900">Otkažite termin</div>
        <div class="mt-1 text-sm-regular text-gray-600">
          Da li ste sigurni da želite da otkažete termin?
        </div>
      </div>
      <ng-template #header>
        <div class="flex align-items-center justify-content-between w-full">
          <div class="flex justify-content-center align-items-center dialog-header-icon">
            <app-slash-circle-01 stroke="#414651" width="20px" height="20px"></app-slash-circle-01>
          </div>
          <app-x-close
            stroke="#ADB0B8"
            width="12"
            height="12"
            class="cursor-pointer"
            (click)="closeCancelDialog()"
          ></app-x-close>
        </div>
      </ng-template>
      <ng-template #footer>
        <div class="flex justify-content-end align-items-center w-full">
          <app-button
            [btnSeverity]="ButtonSeverity.SECONDARY"
            [btnSize]="ButtonSize.MD"
            (btnClicked)="closeCancelDialog()"
          >
            <div class="text-sm-semibold text-gray-900">Odustani</div>
          </app-button>
          <app-button
            class="ml-2-5"
            [isDestructive]="true"
            [btnSeverity]="ButtonSeverity.PRIMARY"
            [btnSize]="ButtonSize.MD"
            (btnClicked)="confirmCancel()"
          >
            <div class="text-sm-semibold text-white">Otkaži termin</div>
          </app-button>
        </div>
      </ng-template>
    </p-dialog>
  }
}
